import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import { useSearchParams } from 'react-router-dom';
import './DigilockerLauncher.css';

const DigilockerRedirect = () => {
  const [searchParams] = useSearchParams();
  const [requestId, setRequestId] = useState(null);
  const [responseData, setResponseData] = useState(null);
  const [status, setStatus] = useState('loading');

  const action = searchParams.get('action');

  // Replace with actual or securely loaded values
const APP_ID = process.env.REACT_APP_BACKEND_APPID;
const API_KEY = process.env.REACT_APP_BACKEND_APIKEY;

  useEffect(() => {
    const idFromParams = searchParams.get('request_id');
    const idFromStorage = localStorage.getItem('digilockerRequestId');

    const resolvedRequestId = idFromParams || idFromStorage;
    setRequestId(resolvedRequestId);

    if (action !== 'digilocker-success') {
      Swal.fire({
        icon: 'error',
        title: 'Invalid Redirection',
        text: 'Unexpected redirect without successful action.',
      });
      setStatus('error');
      return;
    }

    if (!resolvedRequestId) {
      Swal.fire({
        icon: 'error',
        title: 'Missing Request ID',
        text: 'Redirected without request ID.',
      });
      setStatus('error');
      return;
    }

    const fetchKYCResult = async () => {
      try {
        const res = await axios.get(
          `https://digilocker.myearth.id/api/digilocker/fetch/${resolvedRequestId}`,
          {
            headers: {
              'app-id': APP_ID,
              'x-api-key': API_KEY,
            },
          }
        );

        if (res.data.status === 'COMPLETED') {
          setResponseData(res.data.data);
          Swal.fire({
            icon: 'success',
            title: 'KYC Verified',
            text: 'Aadhaar KYC verification was successful.',
          });
          setStatus('success');
          localStorage.removeItem('digilockerRequestId'); // optional cleanup
        } else {
          Swal.fire({
            icon: 'info',
            title: 'Verification Pending',
            text: 'KYC not completed yet. Please try again shortly.',
          });
          setStatus('pending');
        }
      } catch (err) {
        Swal.fire({
          icon: 'error',
          title: 'Fetch Failed',
          text: err.response?.data?.message || 'Unable to retrieve KYC status.',
        });
        setStatus('error');
      }
    };

    fetchKYCResult();
  }, [searchParams, action]);

  return (
    <div className="digilocker-container">
      <h2>🔁 Redirected from Digilocker</h2>
      <p><strong>Request ID:</strong> {requestId || 'Not Available'}</p>

      {status === 'loading' && <p>⏳ Fetching KYC status...</p>}

      {status === 'success' && responseData && (
        <div className="response-box">
          <h3>✅ KYC Data</h3>
          <pre>{JSON.stringify(responseData, null, 2)}</pre>
        </div>
      )}
    </div>
  );
};

export default DigilockerRedirect;
